<h2 mat-dialog-title>
    Detalhes do Log
</h2>

<mat-dialog-content>
    <div class="detail-grid">
        <div class="detail-item">
            <span class="detail-label">Data/Hora</span>
            <span class="detail-value">{{ formatDate(log.datetimeInclusion) }}</span>
        </div>

        <div class="detail-item">
            <span class="detail-label">Tipo</span>
            <span class="detail-value">
                <span class="status-badge" [ngClass]="getBadgeClass(log.idTipoLog)">
                    {{ log.descricaoTipoLog || '-' }}
                </span>
            </span>
        </div>

        <div class="detail-item full-width">
            <span class="detail-label">URL Zoppy</span>
            <span class="detail-value url-value">{{ log.zoppyUrl || '-' }}</span>
        </div>

        <div class="detail-item full-width">
            <span class="detail-label">
                Request
                @if (isRequestJson) {
                <span class="json-badge">JSON</span>
                }
            </span>
            <pre class="detail-code" [class.json-formatted]="isRequestJson">{{ formattedRequest }}</pre>
        </div>

        <div class="detail-item full-width">
            <span class="detail-label">
                Response
                @if (isResponseJson) {
                <span class="json-badge">JSON</span>
                }
            </span>
            <pre class="detail-code" [class.json-formatted]="isResponseJson">{{ formattedResponse }}</pre>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
    <button mat-stroked-button class="btn-secondary" (click)="close()">Fechar</button>
</mat-dialog-actions>